import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth";

/**
 * Generic login gate.
 * - When `requireAdminRole` is true (default), only users with role==="admin" pass; everyone
 *   else is bounced to /admin/login with ?next=<current-path> so they land where they wanted.
 * - When `requireAdminRole` is false, any authenticated user passes.
 */
export default function ProtectedRoute({ children, requireAdminRole = true }) {
  const { user, ready } = useAuth();
  const location = useLocation();
  if (!ready) {
    return (
      <div className="min-h-[60vh] grid place-items-center text-sm text-slate-500" data-testid="auth-loading">
        Checking session…
      </div>
    );
  }
  if (!user || (requireAdminRole && user.role !== "admin")) {
    const next = encodeURIComponent(location.pathname + (location.search || ""));
    return <Navigate to={`/admin/login?next=${next}`} replace />;
  }
  return children;
}
